var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBasketIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.83156 8.9433C2.83153 8.94374 2.83149 8.94418 2.83146 8.94463L1.93135 20.8471L1.93109 20.8505C1.87416 21.5671 2.38566 22.0313 2.83902 22.0313H22.1609C22.6142 22.0313 23.1257 21.5671 23.0688 20.8505L23.0685 20.8472L22.1684 8.95575C22.1684 8.95532 22.1684 8.95489 22.1683 8.95445C22.1173 8.31652 21.6569 7.95774 21.2605 7.95774H18.9541V6.18691H21.2605C22.7253 6.18691 23.8224 7.40763 23.9338 8.81619L23.934 8.81914L24.8341 20.7103C24.8341 20.7108 24.8342 20.7113 24.8342 20.7118C24.9585 22.2867 23.8112 23.8021 22.1609 23.8021H2.83902C1.18885 23.8021 0.0415463 22.2869 0.165674 20.7121C0.165723 20.7115 0.165771 20.7109 0.165819 20.7103L1.06613 8.80506C1.17749 7.3965 2.27458 6.17578 3.73935 6.17578H15.029V7.94661H3.73935C3.34303 7.94661 2.88259 8.30538 2.83156 8.9433Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.16626 3.73432C9.16626 1.84917 10.5755 0.15625 12.4998 0.15625C14.4094 0.15625 15.8333 1.83308 15.8333 3.73432V9.55357C15.8333 10.0426 15.4369 10.439 14.9479 10.439C14.4589 10.439 14.0625 10.0426 14.0625 9.55357V3.73432C14.0625 2.65361 13.2811 1.92708 12.4998 1.92708C11.7129 1.92708 10.9371 2.65978 10.9371 3.73432V9.55357C10.9371 10.0426 10.5407 10.439 10.0517 10.439C9.56267 10.439 9.16626 10.0426 9.16626 9.55357V3.73432Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasketIcon);
export default __webpack_public_path__ + "static/media/basket-icon.91e2061b.svg";
export { ForwardRef as ReactComponent };